//Componentes generales
import React, { useState, useEffect, useContext } from "react";
import { NavLink } from 'react-router-dom';

//Rutas
import Routes_gral from "../../utils/Routes_gral";

//Permisos
import {VER_USUARIOS, VER_PRODUCTOS, VER_GRUPOS, VER_TABACTIVOS, VER_ABMS, VER_TABACTIVOSSUPERVISOR, VER_PROCSPROGRAMADOS} from "../../utils/permisos";

import { PRIMARY_COLOR, NAVBARS, ICONS1 } from "../../constants/colors";

//Estilos
import './Navbar.css';

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faUsersBetweenLines,
  faHouse,
  faBasketShopping,
  faPlusSquare,
  faUsers,
  faCubes,
  faPenToSquare,
  faList,
  faToolbox,
  faFolder,
  faLayerGroup,
  faFaceSmile,
  faScrewdriverWrench,
  faCalendarDays,
  faTableCells,
  faObjectGroup,
  faSquareCheck,
  faCheckDouble,
  faCookieBite,
  faMobile,
  faCalendarCheck,
  faIndustry
} from "@fortawesome/free-solid-svg-icons";
import authContext from "../../context/authentication/authContex";

/*
  Componente encarado de las redirecciones de navegación de la pagina.
    Donde usuario es el usuario en sesión.  style={{color: "rgb(126, 126, 126)"}}
*/
const StyledNavbar_bottom = ({usuario, showTuto}) => {

  const {checkIfAdminOrAdminNoABMs, checkIfSupervisorOrAdmin, checkIfSocio, checkIfCanchero, checkIfGestorReservas, checkIfRevisorReservas, checkIfOnlyRevisor, checkIfMechanic} = useContext(authContext);

  return (
      <div className='navbar-xx' style={{backgroundColor: NAVBARS, position:showTuto ? 'initial' : 'sticky'}}>
        {(!usuario.userType.some(t => t.descr == 'MAQUINISTA')) && <nav className='navbar-container-xx'>

          {
          // usuario.userType.some(item => VER_TABACTIVOS.includes(item.typeName)) &&
          !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && checkIfAdminOrAdminNoABMs() &&
            <NavLink
              to={Routes_gral.activos}
              className='link navbar-item-xx'
            ><FontAwesomeIcon icon={faList} className='icon-navbar' /> <div className='navbar-item-label-xx'>Tablero Activos</div>
            </NavLink>
          }

          { !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && usuario.userType.some(item => VER_TABACTIVOSSUPERVISOR.includes(item.typeName)) &&
            <NavLink
              to={Routes_gral.tableroSupervisor}
              className='link navbar-item-xx'
            ><FontAwesomeIcon icon={faList} className='icon-navbar' /> <div className='navbar-item-label-xx'>Tablero Supervisor</div>
            </NavLink>
          }

        { !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && usuario.userType.some(item => VER_ABMS.includes(item.typeName)) &&
          <NavLink to={Routes_gral.checkListRegistrados} className='navbar-item-xx'>
            <FontAwesomeIcon icon={faCheckDouble} className='icon-navbar'/>
            <div className='navbar-item-label-xx' color="white">Checklist Registrados</div>
          </NavLink>
        }

        {
          // usuario.userType.some(item => VER_PROCSPROGRAMADOS.includes(item.typeName)) &&
          !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && checkIfSupervisorOrAdmin() &&
         <NavLink to={Routes_gral.procsProgramados} className='link navbar-item-xx'>
            <FontAwesomeIcon icon={faCalendarDays} className='icon-navbar' />
            <div className='navbar-item-label-xx'>Procedimientos Programados</div>
          </NavLink>
        }
        {
        // usuario.userType.some(item => VER_PROCSPROGRAMADOS.includes(item.typeName)) &&
          !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && checkIfSupervisorOrAdmin() &&
          <NavLink to={Routes_gral.home} className='link navbar-item-xx'>
            <FontAwesomeIcon icon={faScrewdriverWrench} className='icon-navbar' />
            <div className='navbar-item-label-xx'>Órdenes de Trabajo</div>
          </NavLink>
        }
        {
          // usuario.userType.some(item => VER_ABMS.includes(item.typeName)) &&
          !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && checkIfSupervisorOrAdmin() &&
          <NavLink to={Routes_gral.consumos} className='link navbar-item-xx'>
            <FontAwesomeIcon icon={faCookieBite} className='icon-navbar' />
            <div className='navbar-item-label-xx'>Consumos</div>
          </NavLink>
        }
        {
          !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && checkIfSupervisorOrAdmin() &&
          <NavLink to={Routes_gral.opd} className='link navbar-item-xx'>
            <FontAwesomeIcon icon={faIndustry} className='icon-navbar' />
            <div className='navbar-item-label-xx'>Prod.</div>
          </NavLink>
        }
        {
        // usuario.userType.some(item => VER_ABMS.includes(item.typeName)) &&
          !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && checkIfSupervisorOrAdmin() &&
          <NavLink to={Routes_gral.documentos} className='navbar-item-xx'>
            <FontAwesomeIcon icon={faFolder} className='icon-navbar'/>
            <div className='navbar-item-label-xx' color="white">Documentos</div>
          </NavLink>
        }
        {/* Reservas de Canchas - oculto para revisores y mecánicos */
          !checkIfOnlyRevisor() && !checkIfMechanic() && <NavLink to={Routes_gral.reservasCanchas} className='navbar-item-xx'>
            <FontAwesomeIcon icon={faCalendarCheck} className='icon-navbar'/>
            <div className='navbar-item-label-xx' color="white">Reservas de Canchas</div>
          </NavLink>
        }
        { !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && usuario.userType.some(item => VER_ABMS.includes(item.typeName)) &&
          <NavLink to={Routes_gral.abms} className='navbar-item-xx'>
            <FontAwesomeIcon icon={faObjectGroup} className='icon-navbar'/>
            <div className='navbar-item-label-xx' color="white">ABMs</div>
          </NavLink>
        }
        { !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && usuario.userType.some(item => VER_USUARIOS.includes(item.typeName)) &&
          <NavLink
            to={Routes_gral.reports}
            className='link navbar-item-xx'
          ><FontAwesomeIcon icon={faTableCells} className='icon-navbar' /> <div className='navbar-item-label-xx'>Reports</div>
          </NavLink>
        }
        { !checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() && !checkIfOnlyRevisor() && usuario.userType.some(item => VER_TABACTIVOSSUPERVISOR.includes(item.typeName)) &&
          <NavLink
            to={Routes_gral.appMobile}
            className='link navbar-item-xx'
          ><FontAwesomeIcon icon={faMobile} className='icon-navbar' /> <div className='navbar-item-label-xx'>App Mobile</div>
          </NavLink>
        }
        </nav>}
      </div>
  
  );
};
export default StyledNavbar_bottom;